import i18n from '@/libs/i18n/index'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import { ref } from '@vue/composition-api'

export default function usePagesList() {
  function convertResource(resource) {
    return {
      ...resource,
      roleName: resource.roleName,
      roleLink: { name: 'pages-roles-edit', params: { id: resource._id } },
    }
  }

  const MODULE_NAME = 'roles'
  const ENDPOINT = 'roles'
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const permissions = ref({})
  function convertPermissions(rawPermission) {
    rawPermission.forEach(item => {
      const itemSplit = item.split('/')
      if (itemSplit.length === 2) {
        if (!permissions.value[itemSplit[0]]) {
          permissions.value[itemSplit[0]] = []
        }
        permissions.value[itemSplit[0]].push(itemSplit[1])
      }
    })
  }

  // Table Handlers
  const tableColumns = [
    {
      key: 'roleName', label: i18n.t('general.roleName'), linkKey: 'roleLink', sortable: false,
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: false, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: false, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const fetchAllRoles = params => store
    .dispatch('crud/fetchList', {
      queryParams: {
        ...params,
      },
      endpoint: 'roles',
    })
    .then(response => ({
      data: response.data.map(item => convertResource(item)),
      total: response.data.length,
    }))

  const fetchPermissions = params => store
    .dispatch('crud/fetchList', {
      queryParams: {
        ...params,
      },
      endpoint: 'roles/permissions',
    })
    .then(response => convertPermissions(response.data))

  return {
    ...entity,
    convertResource,
    fetchAllRoles,
    fetchPermissions,
    permissions,
    tableColumns,
  }
}
